module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.location["verdieping-klankbordgroep"]) ? _c('div', {
    staticClass: "grid-item focus-group",
    class: _vm.classList
  }, [_c('div', {
    staticClass: "author small-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title.rendered))])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image_en.sizes['grid-small']),
      expression: "item.acf.image_en.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e()]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location["nieuws"]) ? _c('div', {
    staticClass: "grid-item focus-group",
    class: _vm.classList
  }, [_c('a', {
    attrs: {
      "href": _vm.item.acf.target_link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "author small-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title.rendered))])]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image_en.sizes['grid-small']),
      expression: "item.acf.image_en.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e()]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.location["verdieping-klankbordgroep"] && !_vm.location["nieuws"] && _vm.item.acf !== false) ? _c('div', {
    staticClass: "grid-item",
    class: _vm.classList
  }, [_c('div', {
    staticClass: "author small-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.acf.author))])]), _vm._v(" "), (_vm.location.verdieping) ? _c('router-link', {
    staticClass: "roman",
    attrs: {
      "to": {
        name: _vm.item.slug,
        params: {
          language: _vm.language
        }
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.language === "nl") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title.rendered)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.title_en)
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.screenSize.mobile) ? _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.item.tags), function(tag) {
    return _c('dsTagItemInline', {
      attrs: {
        "tag": tag,
        "tags": _vm.tags,
        "language": _vm.language
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image_en.sizes['grid-small']),
      expression: "item.acf.image_en.sizes['grid-small']"
    }]
  }) : _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  })])]) : _c('router-link', {
    staticClass: "roman",
    attrs: {
      "to": {
        name: 'single',
        params: {
          language: _vm.language,
          slug: _vm.item.slug
        }
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.language === "nl") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.title.rendered)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.title_en)
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.screenSize.mobile) ? _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.item.tags), function(tag) {
    return _c('dsTagItemInline', {
      attrs: {
        "tag": tag,
        "tags": _vm.tags,
        "language": _vm.language
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image_en.sizes['grid-small']),
      expression: "item.acf.image_en.sizes['grid-small']"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.item.acf.image.sizes['grid-small']),
      expression: "item.acf.image.sizes['grid-small']"
    }]
  }) : _vm._e()])]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
    staticClass: "description secondary-color small-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60449392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsGridItem.vue
// module id = 218
// module chunks = 2